export var PillexaRole;
(function (PillexaRole) {
    PillexaRole["PHYSICIAN"] = "physician";
    PillexaRole["BRAND_ADMIN"] = "brand_admin";
    PillexaRole["PHARMACY"] = "pharmacy";
    PillexaRole["ADMIN"] = "admin";
    PillexaRole["FULFILLMENT_ASSOCIATE"] = "fulfillment_associate";
    PillexaRole["DEV"] = "dev";
    PillexaRole["PHARMACY_ASSISTANT"] = "pharmacy_assistant";
    PillexaRole["SUPPORT"] = "support";
})(PillexaRole || (PillexaRole = {}));
//# sourceMappingURL=pharmacy.js.map